import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { IMAGE_URLS } from 'src/app/core/constants/image-source';

@Component({
  standalone: true,
  selector: 'base-explore-button',
  templateUrl: './explore-button.component.html',
  styleUrls: ['./explore-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, RouterModule]
})
export class ExploreButtonComponent {

  IMAGE_URLS = IMAGE_URLS;



  readonly label = input<string>('');

}

